import apiClient from "./client.js";

/**
 * Fetch the active workspace's details.
 */
export async function fetchCurrentWorkspace() {
  const res = await apiClient.get("/workspaces/me");
  return res.data.data;
}

/**
 * Update the active workspace.
 * @param {{ name?: string }} data
 */
export async function updateCurrentWorkspace(data) {
  const res = await apiClient.patch("/workspaces/me", data);
  return res.data.data;
}

/**
 * Fetch all members of the active workspace.
 */
export async function fetchMembers() {
  const res = await apiClient.get("/workspaces/members");
  return res.data.data;
}

export async function updateMemberRole(userId, role) {
  const res = await apiClient.patch(`/workspaces/members/${userId}`, { role });
  return res.data.data;
}

export async function removeMember(userId) {
  await apiClient.delete(`/workspaces/members/${userId}`);
}

export async function fetchWorkspaceInvitations() {
  const res = await apiClient.get("/workspaces/invitations");
  return res.data.data;
}

export async function fetchWorkspaceInvitationDetails(token) {
  const res = await apiClient.get(`/workspaces/invitations/${token}`);
  return res.data.data;
}

export async function createWorkspaceInvitation(data) {
  const res = await apiClient.post("/workspaces/invitations", data);
  return res.data.data;
}

export async function revokeWorkspaceInvitation(invitationId) {
  await apiClient.delete(`/workspaces/invitations/${invitationId}`);
}

export async function acceptWorkspaceInvitation(token) {
  await apiClient.post("/workspaces/invitations/accept", { token });
}

// ---------------------------------------------------------------------------
// Child workspace management
// ---------------------------------------------------------------------------

export async function fetchChildWorkspaces() {
  const res = await apiClient.get("/workspaces");
  return res.data.data;
}

export async function createChildWorkspace(data) {
  const res = await apiClient.post("/workspaces", data);
  return res.data.data;
}

export async function deleteChildWorkspace(id) {
  await apiClient.delete(`/workspaces/${id}`);
}

export async function fetchChildMembers(id) {
  const res = await apiClient.get(`/workspaces/${id}/members`);
  return res.data.data;
}

export async function addChildMember(id, data) {
  const res = await apiClient.post(`/workspaces/${id}/members`, data);
  return res.data.data;
}

export async function removeChildMember(id, userId) {
  await apiClient.delete(`/workspaces/${id}/members/${userId}`);
}
